import { render, staticRenderFns } from "./PolimixStockProduct.vue?vue&type=template&id=e422bdd6&"
import script from "./PolimixStockProduct.vue?vue&type=script&lang=js&"
export * from "./PolimixStockProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports